import {
  AG_GRID_LOCALE_DE,
  AG_GRID_LOCALE_EN,
  AG_GRID_LOCALE_FR,
} from '@ag-grid-community/locale';
import { createBrzThemes } from '@brz/brz-global-ag-grid-theme';
import { typedMemo } from '@utils';
import { ColDef, themeQuartz } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipCellRenderer } from './TooltipCellRenderer';
import { TooltipHeaderRenderer } from './TooltipHeaderRenderer';

const { brzThemeWide } = createBrzThemes(themeQuartz);

interface EmbeddedListViewProps<T> {
  rowData: T[];
  columnDefs: ColDef[];
  height?: number | string;
  maxHeight?: number | string;
}

export const EmbeddedListView = typedMemo(
  <T,>({ rowData, columnDefs }: Readonly<EmbeddedListViewProps<T>>) => {
    const { i18n } = useTranslation();

    const defaultColDef = useMemo<ColDef>(
      () => ({
        cellRenderer: TooltipCellRenderer,
        headerComponent: TooltipHeaderRenderer,
        resizable: true,
        sortable: true,
      }),
      [],
    );

    const getLocaleText = useMemo(() => {
      switch (i18n.language) {
        case 'de':
          return AG_GRID_LOCALE_DE;
        case 'fr':
          return AG_GRID_LOCALE_FR;
        default:
          return AG_GRID_LOCALE_EN;
      }
    }, [i18n.language]);

    return (
      <div className="ag-theme-brz" style={{ height: '100%', width: '100%' }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={{ mode: 'singleRow', enableClickSelection: false }}
          theme={brzThemeWide}
          localeText={getLocaleText}
          suppressMenuHide={true}
          suppressContextMenu={true}
          containerStyle={{ height: '100%', width: '100%', minHeight: '140px' }}
        />
      </div>
    );
  },
);
